<template>
  <div>
    <v-dialog
      v-model="open"
      persistent
      max-width="500"
    >
      <v-card color="light" class="pa-2">

        <v-toolbar
          dark
          color="light"
          elevation="0"
        >
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click="open = false"
            color="accent"
            large
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <div class="text-center color-blue font-general-r">
            <div style="position: relative; text-align:center" class="mb-10 d-none d-sm-none d-md-block">
              <span class="font-backward session_name font-weight-bold" style="position: absolute; bottom: 10px; right: 0; left: 70px; color: white">
                {{ is_auth ? `¡${user.name}!` : '¡Hola!' }}
              </span>
              <img class="img-session_name" src="@/assets/store/home/session_name.png" alt="">
            </div>
            <h2 :class="!user.subscription && data_home_page.enabled_subscriptions ? 'mb-10' : 'mb-0'">
              Tu costo de envío es de {{ currencyFormat(price_delivery) }}
            </h2>
            <div v-if="!user.subscription && data_home_page.enabled_subscriptions">
              <h2>¡Genera tu membresía!</h2>
              <span class="h5">Y te lo enviamos gratis</span>
              <br>
              <br>
              <br>
            </div>
            <v-btn
              v-if="!user.subscription && data_home_page.enabled_subscriptions"
              color="primary"
              elevation="0"
              class="nv-btn nv-btn-medium"
              @click="openItacates()"
            >
              CREAR MEMBRESIA
            </v-btn> <br><br>
            <v-btn
              color="primary"
              elevation="0"
              class="nv-btn nv-btn-medium"
              @click="open = false"
            >
              CONTINUAR
            </v-btn>
          </div>

        </v-card-text>
      </v-card>
    </v-dialog>

    <modal-view-itacates :open="open_modal_subscription" @closeModal="open_modal_subscription = false"/>
  </div>

</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { currencyFormat } from '@/helpers'
import ModalViewItacates from '@/components/store/ModalViewItacates'

export default {
  components: { ModalViewItacates },
  props: ["message", 'price_delivery'],
  data() {
    return {
      open_modal_subscription: false,
      open: false
    }
  },
  computed: {
    ...mapState(['user', 'is_auth', 'data_home_page']),
    ...mapGetters(['total_cart'])
  },
  methods: {
    openItacates() {
      this.open = false
      this.open_modal_subscription = true
    },
    openDialog() {
      this.open = true;
    },
    close() {
      this.open = false;
    },
    currencyFormat(total) {
      return currencyFormat(total)
    }
  }
}
</script>

<style scoped>
  .img-popup-message {
    width: 150px
  }
</style>
